import React from 'react';

export const CloseIcon = () => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.05 11.25L6 7.2L1.95 11.25L0.75 10.05L4.8 6L0.75 1.95L1.95 0.75L6 4.8L10.05 0.75L11.25 1.95L7.2 6L11.25 10.05L10.05 11.25Z" fill="#868686"/>
  </svg>
);
